import React, { Component } from 'react';
import './index.scss';
import Hero2 from '../../parts/Hero2/index';
import Timeline from '../../parts/Timeline/index';
import DataHero2 from '../../json/dataHero2.json';
import DataTimeline from '../../json/timeline.json';

class Competitionuniv extends Component{
    constructor(props){
        super(props);
    }
    render() {
        return (
            <div>
                <Hero2 data={DataHero2.competitionuniv} isLogin = {this.props.isLogIn}/>

                <div className="downArrow">&#8675;</div>
                
                <h2 className="my-5">Timeline</h2>
                <Timeline data={DataTimeline.competitionuniv}/> 

                <div className="ketentuan-peserta pb-5 mb-5 pr-md-1 pr-4">
                    <h4 className="ml-4">Ketentuan Peserta:</h4>
                    <ol>
                        <li>Peserta adalah <b>Mahasiswa aktif S1 / sederajat berusia maksimal 27 tahun.</b></li>
                        <li>Peserta bersifat kelompok dengan jumlah anggota <b>maksimal 3 orang.</b></li>
                        <li>Satu tim boleh memiliki anggota lintas fakultas dalam universitas yang sama.</li>
                        <li>Peserta wajib <b><i>follow</i> Instagram @impulseitb</b> serta share grand poster <b>Innovation Competition IMPULSE ITB 2021</b> di story akun Instagram pribadi dengan tag Instagram <b>@impulseitb</b> dan 5 teman.<br></br>Grand poster dapat diunduh di <a href="https://bit.ly/PosterIMPULSE" target="_blank" className="green"><b>bit.ly/PosterIMPULSE</b></a></li>
                    </ol>
                    
                    <h5 className="ml-4 green">Promo Pendaftaran</h5>
                        <p className="ml-4 mb-0">Biaya Pendaftaran Normal: Rp205.000</p>
                        <p className="ml-4">Biaya Pendaftaran Promo: Rp185.000</p>
                    
                    <h5 className="ml-4 green">Cara Mendapatkan Promo:</h5>
                    <ol>
                        <li>Unduh twibbon pada <a href="https://bit.ly/TwibbonIC2021" target="_blank" className="green"><b>bit.ly/TwibbonIC2021</b></a> dan unggah twibbon beserta caption pada akun <b>Instagram</b> minimal satu anggota  tim, tag akun instagram Impulse yaitu <b>@impulseitb</b>, lalu screenshot.</li>
                        <li>Kirim poster dari <b>Innovation Competition</b> beserta <b>caption</b> yang dapat diunduh pada <a href="https://bit.ly/PosterIMPULSE" target="_blank" className="green"><b>bit.ly/PosterIMPULSE</b></a> ke 5 grup berbeda, lalu <i>screenshot</i> buktinya.</li>
                        <li>Gabungkan hasil <i>screenshot</i> ke dalam file yang di zip dan lampirkan saat ingin mendaftar.</li>
                    </ol>
                    <p className="ml-4">Untuk pembayaran sebelum tanggal <b>1 Desember 2020</b> akan mendapatkan <b>eksklusif online company visit!</b></p>
                </div>

                <h2>Hadiah</h2>
                <div className="row align-items-end row-cols-3 podium container text-center my-5 mx-auto px-0 w-75 font-weight-bold">
                    <div className="col juara3 px-1">
                        Rp3.000.000
                        <p className="py-3 mb-0 rounded-sm bg-green">3</p>
                    </div>
                    <div className="col juara3 px-1">
                        Rp7.000.000*
                        <p className="py-5 mb-0 rounded-sm bg-green">1</p>
                    </div>
                    <div className="col juara3 px-1">
                        Rp5.000.000
                        <p className="py-4 mb-0 rounded-sm bg-green">2</p>
                    </div>
                </div>
                <ul className="benefit-univ mb-5 pr-mb-1 pr-4">
                    <li><b>Juara 1</b> akan mendapatkan Program pra inkubasi oleh BPPT</li>
                    <li>Ekslusif <b>Online Company Visit</b> Untuk <b>50 Tim Terbaik</b></li>
                    <li><b>E-sertifikat</b> untuk semua peserta</li>
                </ul>
            </div>
        )
    }
}

export default Competitionuniv;